import { IconPlus } from "@tabler/icons-react"
import type { FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	position: "top" | "between" | "bottom"
	label: string
	onClick(): void
}
const AddBlockIndicator: FC<Props> = ({ position, label, onClick }) => (
	<div
		className={cn(
			"group/insert pointer-events-none absolute right-0 left-0 z-2 flex items-center justify-center px-4",
			position === "top" && "top-3",
			position === "between" && "top-0 -translate-y-1/2",
			position === "bottom" && "-top-3",
		)}
	>
		<span className="h-px w-6 bg-indigo-400/60 transition-all group-focus-within/insert:w-10 group-focus-within/insert:bg-indigo-500 group-hover/insert:w-10 group-hover/insert:bg-indigo-500" />
		<button
			type="button"
			title={label}
			aria-label={label}
			onClick={onClick}
			className="pointer-events-auto flex cursor-pointer items-center gap-1 overflow-hidden rounded-full border border-indigo-300 bg-white p-1.5 text-xs font-bold text-indigo-600 shadow-sm transition-all hover:border-indigo-500 hover:px-3 hover:shadow-md focus-visible:px-3 focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:outline-none"
		>
			<IconPlus className="size-4 shrink-0" />
			<span className="max-w-0 whitespace-nowrap opacity-0 transition-all group-focus-within/insert:max-w-20 group-focus-within/insert:opacity-100 group-hover/insert:max-w-20 group-hover/insert:opacity-100">
				Add block
			</span>
		</button>
		<span className="h-px w-6 bg-indigo-400/60 transition-all group-focus-within/insert:w-10 group-focus-within/insert:bg-indigo-500 group-hover/insert:w-10 group-hover/insert:bg-indigo-500" />
	</div>
)

export default AddBlockIndicator
